import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'antd';
import Placeholder from './components/Placeholder';
import './Template.css';

const TwoThirdTemplate = props => {
    const [components] = useState(props.components || []);
    const [editMode] = useState(props.editMode);

    return (
        <React.Fragment>
            <Row className="template-row default-header">
                <Col span={24}>
                    <Placeholder fieldName="header" compList={props.template.header} editMode={editMode}>
                        {components[0]}
                    </Placeholder>
                </Col>
            </Row>
            <Row className="template-row default-content">
                <Col span={16}>
                    <Placeholder fieldName="colLeft" compList={props.template.colLeft} editMode={editMode}>
                        {components[1]}
                    </Placeholder>
                </Col>
                <Col span={8}>
                    <Placeholder fieldName="colRight" compList={props.template.colRight} editMode={editMode}>
                        {components[2]}
                    </Placeholder>
                </Col>
            </Row>
            <Row className="template-row default-footer">
                <Col span={24}>
                    <Placeholder fieldName="footer" compList={props.template.footer} editMode={editMode}>
                        {components[3]}
                    </Placeholder>
                </Col>
            </Row>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n,
    template: state.templates.template
});

export default connect(
    mapStateToProps,
    null
)(TwoThirdTemplate);
